import { cloneDeep, orderBy } from 'lodash'

import { DashboardsViews } from './types'

import { useRepositoriesStore } from '@/store/repositories/index'

const DASHBOARDS_VIEWS_VERSION = 'dashboardsViewsVersion'

const runMigrations = async (dashboardViews: DashboardsViews[], migrations: Record<string, any>) => {
  const repositoriesStore = useRepositoriesStore()
  const dateRegex = new RegExp(/\/(\d{4}\d{2}\d{2})/)
  const version = repositoriesStore.getCurrentUISettings?.[DASHBOARDS_VIEWS_VERSION] || '19700101'
  const orderedList = orderBy(Object.keys(migrations))
  const lastMigration = orderedList.at(-1)
  const lastMigrationDate = lastMigration && dateRegex.exec(lastMigration)?.[1]
  if (!lastMigrationDate) return null
  const result: DashboardsViews[] = []
  const data = cloneDeep(dashboardViews)
  if (+version < +lastMigrationDate) {
    let findIndex = version ? orderedList.findIndex(migration => {
      const migrationDate = dateRegex.exec(migration)
      return migrationDate?.[1] === version
    }) : -1
    const migrationsToRun = orderedList.slice(findIndex + 1).map(migration => migrations[migration])
    if (!migrationsToRun.length) return null
    for (const migration of migrationsToRun) {
      const newData = await migration.default(data)
      result.push(...newData)
    }
  }
  if (!lastMigration || lastMigrationDate === version) return null
  repositoriesStore.setCurrentUISettings([[DASHBOARDS_VIEWS_VERSION, lastMigrationDate]])
  return result
}

export default async function runDashboardsSettingsMigrations(dashboardViews: DashboardsViews[]) {
  const migrations = (import.meta as any).glob('../migrations/*.ts', { eager: true })
  return await runMigrations(dashboardViews, migrations)
}
